/**
 * The demo's customers, as the front door lists them (UX spec v3 §6.10, copy
 * §8.2). The door's words are its own; WHO is offered is the bank's: P0-1
 * (DCTA-192) reads `GET /v1/session/personas` (ask (j)) and keeps only the rows
 * whose id it lists (app/door-model.ts › offered) — this table alone when that
 * read fails. The ids are the seed's and `MOCK_LOGIN=1` refuses any other. Every
 * title is the seed's own name and age (test/signin.spec.ts reads customers.json:
 * QA DW-9 found Ng Chee Hong and Rahim Daud with each other's age, DCTA-190).
 *
 * The profile is what the server uses to pick the payload's lifetime (120 s /
 * 180 s) and what turns the screen to large type.
 */
export interface Persona {
  readonly key: "wj" | "ml" | "dk" | "nch" | "rd";
  readonly customerId: string;
  /** The name the door's button uses: "Continue as Wei Jie". */
  readonly name: string;
  readonly title: string;
  /** P0-9 (DCTA-192): one short line in plain words — a " · " list broke at its separators in the door's column. */
  readonly note: string;
  readonly initials: string;
  readonly profile: "standard" | "large_type";
  /** Under the "2 more customers" disclosure, so the first screen stays short (three choices since DCTA-186's Daniel Koh). */
  readonly more: boolean;
}

export const PERSONAS: readonly Persona[] = [
  /**
   * DCTA-186 (docs/specs/fe-persona-daniel-koh-dcta186.md): the fifth demo customer, the video's hero — round balances, so
   * every change is obvious. Seed `cus_dk005`. DCTA-236 (Umakhan, 16 Oct): first on the door and its default ("Continue as
   * Daniel Koh") — the door chooses `PERSONAS[0]`; the others keep their order after him.
   */
  {
    key: "dk",
    customerId: "cus_dk005",
    name: "Daniel Koh",
    title: "Daniel Koh, 38",
    note: "Round balances, easy to follow",
    initials: "DK",
    profile: "standard",
    more: false,
  },
  {
    key: "wj",
    customerId: "cus_wj001",
    name: "Wei Jie",
    title: "Wei Jie, 34",
    note: "Savings, card and shares",
    initials: "WJ",
    profile: "standard",
    more: false,
  },
  {
    key: "ml",
    customerId: "cus_ml002",
    name: "Mdm Lim",
    title: "Mdm Lim, 68",
    note: "Large type, extra safety checks",
    initials: "ML",
    profile: "large_type",
    more: false,
  },
  {
    key: "nch",
    customerId: "cus_nch003",
    name: "Ng Chee Hong",
    title: "Ng Chee Hong, 41",
    note: "Identity check lapsed",
    initials: "NC",
    profile: "standard",
    more: true,
  },
  {
    key: "rd",
    customerId: "cus_rd004",
    name: "Rahim Daud",
    title: "Rahim Daud, 52",
    note: "Identity check due soon",
    initials: "RD",
    profile: "standard",
    more: true,
  },
];
